import { useEffect, useState } from 'react';
import { pollAiCaptions, createAICaptions, destroyCaptions } from '../../../entities/helpers/thankview-helper';
import { useRecorder } from '../hooks/recorder-context';
import { useThankViewAuth } from 'apps/signal-video/contexts/thankview-auth-context';
import EverTrue from 'app';

const useAiCaptions = () => {
  const { selectedVideo: { libraryVideo: { id = null, caption_processing = false, caption_url = null } = {} } = {} } =
    useRecorder();

  const { getValidToken } = useThankViewAuth();
  const [captionsProcessing, setCaptionsProcessing] = useState(caption_processing);
  const [captions, setCaptions] = useState(caption_url || '');

  useEffect(() => {
    let isSubscribed = true;
    let timeoutId = null;

    const getCaptionsStatus = async () => {
      try {
        const token = await getValidToken();
        if (token) {
          const {
            data: { processingState, captionUrl },
          } = await pollAiCaptions(id, token);

          if (!isSubscribed) return;

          if (processingState === 'Complete') {
            setCaptionsProcessing(false);
            setCaptions(captionUrl);
            return;
          }

          // Continue polling if still processing
          timeoutId = setTimeout(getCaptionsStatus, 5000);
        }
      } catch (error) {
        if (!isSubscribed) return;
        console.error('Error polling captions:', error);
      }
    };

    if (captionsProcessing) {
      getCaptionsStatus();
    }

    // Cleanup function
    return () => {
      isSubscribed = false;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [id, caption_processing, getValidToken, captionsProcessing]);

  const createCaptions = async () => {
    try {
      EverTrue.track.set('signal_video', { type: 'signal_video_added_cc' });
      const token = await getValidToken();
      const res = await createAICaptions(id, token);
      if (res) {
        setCaptionsProcessing(true);
      }
    } catch (error) {
      console.error('Error creating captions:', error);
    }
  };

  const deleteCaptions = async () => {
    const token = await getValidToken();
    destroyCaptions(id, token);
    setCaptionsProcessing(false);
  };

  return {
    captionsProcessing,
    createCaptions,
    deleteCaptions,
    captions,
  };
};

export default useAiCaptions;
